export default function Phase7() {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Phase Header */}
        <div className="flex items-center justify-center mb-8">
          <img 
            src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2160517458/settings_images/c821fd2-60ad-dfbb-b7b-3c7076dbb748_0a9554db-dfc8-42b5-bbf2-fe0e7fe8eafe.png" 
            alt="Phase Icon" 
            className="w-16 h-16"
          />
        </div>

        <div className="max-w-4xl mx-auto text-left mb-12">
          <h4 className="text-xl font-bold text-gray-900 mb-2">
            <span>Phase 6:</span>
          </h4>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
            <span>AI Video Editing &amp; Enhancement</span>
          </h2>
        </div>

        {/* Video - Desktop */}
        <div className="max-w-6xl mx-auto mb-12 hidden md:block">
          <div 
            className="relative w-full overflow-hidden rounded-lg" 
            style={{ 
              paddingBottom: '56.25%',
              touchAction: 'pan-y',
              WebkitOverflowScrolling: 'touch'
            }}
          >
            <iframe 
              src="https://fast.wistia.net/embed/iframe/ep2uovkp5t?web_component=true&seo=true&playsinline=1&autoplay=1&muted=1" 
              title="Ai video editing autopod" 
              allow="autoplay; fullscreen" 
              allowFullScreen
              className="absolute top-0 left-0 w-full h-full rounded-lg"
              style={{ 
                border: 'none',
                pointerEvents: 'auto',
                maxWidth: '100%',
                maxHeight: '100%'
              }}
              loading="lazy"
            ></iframe>
          </div>
        </div>

        {/* Video - Mobile */}
        <div className="max-w-6xl mx-auto mb-12 md:hidden">
          <div 
            className="relative w-full overflow-hidden rounded-lg" 
            style={{ 
              paddingBottom: '56.25%',
              touchAction: 'pan-y',
              WebkitOverflowScrolling: 'touch'
            }}
          >
            <iframe 
              src="https://fast.wistia.net/embed/iframe/36owu89y9p?web_component=true&seo=true&playsinline=1&autoplay=1&muted=1" 
              title="Ai video editing (mobile)" 
              allow="autoplay; fullscreen" 
              allowFullScreen
              className="absolute top-0 left-0 w-full h-full rounded-lg"
              style={{ 
                border: 'none',
                pointerEvents: 'auto',
                maxWidth: '100%',
                maxHeight: '100%'
              }}
              loading="lazy"
            ></iframe>
          </div>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          <div className="bg-white rounded-lg shadow-md p-8 text-center">
            <img 
              src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2160737798/settings_images/d888863-2cb3-50be-ab41-fe2a46eef4_Ai_editing_tools_v2.png" 
              alt="AI Editing Tools" 
              className="w-full mb-6 rounded-lg"
            />
            <h5 className="text-xl font-bold text-gray-900 mb-4">
              <span><strong>Best AI Editing Tools</strong></span>
            </h5>
            <ul className="text-left space-y-3 text-base text-gray-700">
              <li className="flex items-start">
                <span className="text-blue-600 mr-2">✓</span>
                <span>Edit podcasts in SECONDS!</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 mr-2">✓</span>
                <span>Best AI auto caption software</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 mr-2">✓</span>
                <span>The top 3 FREE tools that will save you hours per week!</span>
              </li>
            </ul>
          </div>

          <div className="bg-white rounded-lg shadow-md p-8 text-center">
            <img 
              src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2160737798/settings_images/eeda7a1-4784-c0f3-3f86-fb2cefff3c60_0f11c576-06c6-4ef9-9049-c4f311d72158.png" 
              alt="AI Audio Enhancement" 
              className="w-full mb-6 rounded-lg"
            />
            <h5 className="text-xl font-bold text-gray-900 mb-4">
              <span><strong>AI Audio Enhancement</strong></span>
            </h5>
            <ul className="text-left space-y-3 text-base text-gray-700">
              <li className="flex items-start">
                <span className="text-blue-600 mr-2">✓</span>
                <span>How to quickly improve ANY audio</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 mr-2">✓</span>
                <span>Turn "cheap" microphones into professional sounding equipment</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-600 mr-2">✓</span>
                <span><span>Recover audio that's been "ruined"</span></span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
